export const COMPILED_SPEC_VERSION = '0';
export const COMPILED_FILENAME = '.remedy.compiled.json';
/**
 * SHA-256 via WebCrypto (available in Node ≥ 20 and all modern browsers).
 * Returns `sha256:<64 hex>` — matches the SPEC §5.2 shape exactly.
 */
export async function sha256(text) {
    const bytes = new TextEncoder().encode(text);
    const digest = await globalThis.crypto.subtle.digest('SHA-256', bytes);
    const hex = Array.from(new Uint8Array(digest))
        .map((b) => b.toString(16).padStart(2, '0'))
        .join('');
    return `sha256:${hex}`;
}
//# sourceMappingURL=artifact.js.map